export default __webpack_public_path__ + "static/media/Data.6e447c5b.png";